// extracted by css-extract-rspack-plugin
export default {"newOptionName":"single-select-field-module__newOptionName__xjhnQWp"};